// Activity status
// TODO configure based on routes.js, or add help links
// to routes.js
export const helpSiteBaseURL = "https://help.amiralearning.com"

export const teacherInProductHelpLinks = [{
    pathname: '/teacher/reports/type/benchmark',
    link: `${helpSiteBaseURL}/s/article/Teacher-Reports-Benchmark-Report`
  },{
    pathname: '/teacher/reports/type/tracking',
    link: `${helpSiteBaseURL}/s/article/Teacher-Reports-Usage-Report`
  },{
    pathname: '/teacher/reports/type/progress',
    link: `${helpSiteBaseURL}/s/article/Teacher-Reports-Progress-Report`
  },{
    pathname: '/teacher/reports/type/parent',
    link: `${helpSiteBaseURL}/s/article/Teacher-Reports-Parent-Report`
  },{
    pathname: '/teacher/reports/type/diagnostic',
    link: `${helpSiteBaseURL}/s/article/Teacher-Reports-Skills-Status-Report`
  },{
    pathname: '/teacher/reports/type/readingrope',
    link: `${helpSiteBaseURL}/s/article/Teacher-Reports-Reading-Rope-Insights-Report`
  },{
    pathname: '/teacher/reports/type/skillsstatus',
    link: `${helpSiteBaseURL}/s/article/Teacher-Reports-Skills-Status-Report`
  },{
    pathname: '/teacher/reports/type/skillsdiagnostic',
    link: `${helpSiteBaseURL}/s/article/Teacher-Reports-Skills-Diagnostic-Report`
  },{
    pathname: '/teacher/reports/type/dyslexiarisk',
    link: `${helpSiteBaseURL}/s/article/Teacher-Reports-Reading-Risk-Report`
  },{
    pathname: '/teacher/gradebook/activities',
    link: `${helpSiteBaseURL}`
  },{
    pathname: '/teacher/gradebook/scoring/',
    link: `${helpSiteBaseURL}/s/article/How-do-I-listen-to-how-students-read-with-Amira`
  }
];

export const studentInProductHelpLinks = {
  "enableMicrophoneGeneral": `${helpSiteBaseURL}/s/article/Help-Amira-Can-t-Hear`,
  "networkPingGeneral": `${helpSiteBaseURL}/s/article/What-are-the-technical-requirements`,
}

export const educatorSupportHelpLinks = {
  studentPracticeExperience: `${helpSiteBaseURL}/s/article/Amira-Student-Experience`,
  practiceErrorDetection: `${helpSiteBaseURL}/s/article/Understanding-Amira-Error-Messages`
}